var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import { useCallback } from 'react';
import { apiCreateProffitSearchPptx } from '../../../../actions/ProffitSearchControlAction';
import { apiDeleteSlideSelectAll } from '../../../../actions/ProffitSearchSelectAction';
import { wrapDispatch } from '../../../action';
export const useSlideSearchCommonPptx = (dispatch) => {
    const onClickPptx = useCallback((slides) => __awaiter(void 0, void 0, void 0, function* () {
        const now = moment().format('YYYYMMDD_HHmmss');
        yield wrapDispatch(dispatch, apiCreateProffitSearchPptx({ slides }, { fileName: `ProffitSearch_${now}.pptx` }));
        // 選択状態を全削除
        yield wrapDispatch(dispatch, apiDeleteSlideSelectAll());
    }), [dispatch]);
    return {
        onClickPptx,
    };
};
export default useSlideSearchCommonPptx;
